import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const partners = [
    {
        name: 'Pronto',
        logo: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/692d6394a23762baf1ff05b8/061d63c13_66e9a0866f44a6cd2bb1923d_Open_Graph-removebg-preview.png',
        url: 'https://www.prontohq.com/'
    },
    {
        name: 'Clearbase',
        logo: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/692d6394a23762baf1ff05b8/4e1249752_Designsanstitre.png',
        url: 'https://www.clearbase.fr/'
    },
];

export default function PartnersSection() {
    const { t } = useTranslation(['admin']);
    return (
        <section className="relative py-16 bg-[#0a0a0a]" style={{ contentVisibility: 'auto', containIntrinsicSize: '600px' }}>
            {/* Gradient line */}
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
            
            <div className="max-w-4xl mx-auto px-6">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-center mb-10"
                >
                    <span className="text-xs uppercase tracking-[0.2em] text-white/30">
                        {t('admin:landing.partners.heading')}
                    </span>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.1 }}
                    className="flex items-center justify-center gap-10 sm:gap-16 md:gap-24"
                >
                    {partners.map((partner) => (
                        <a
                            key={partner.name}
                            href={partner.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center justify-center"
                        >
                            <img
                                src={partner.logo}
                                alt={partner.name}
                                width={220}
                                height={90}
                                loading="lazy"
                                decoding="async"
                                sizes="(max-width: 768px) 140px, 220px"
                                className={`${partner.name === 'Clearbase' ? 'h-32 sm:h-40 md:h-48' : 'h-20 sm:h-24 md:h-32'} w-auto object-contain opacity-50 hover:opacity-80 transition-all duration-300 brightness-0 invert`}
                            />
                        </a>
                    ))}
                </motion.div>
            </div>
        </section>
    );
}